import noop from 'utils/noop';

export const useRumPageView = noop;
/**
 * uncomment and add back lib if we want web rum again
 
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useRumPageView = (key: string, name: string, context?: object) => {
  useEffect(() => {
    void datadogRum.startView(name);
  }, [context, key, name]);
};
 */
